import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import {Button, Typography, Grid} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { data } from './local';


const ThankYou: FunctionComponent<any> = () => {

    const languageSelected:any = useSelector((state:any) => state.lang);
    const languageData: any = data;
    const { Submitted } = languageData[languageSelected];

    let history = useHistory();
    const handleSubmit = (event: any) => {
        history.push("/")
    }

    return (
        <React.Fragment>
            <Grid container direction='column' justify="space-between" alignItems="center" className={styles.TYcontainer}>
                    <Typography className={styles.TYHeader}>{Submitted.thankYou}</Typography>
                    <img className={styles.TYimage} src='../logos/colors.png' width={550} height={500}/><br/>
                    <Button className={styles.TYbutton} variant="outlined" color="primary" onClick={handleSubmit}>
                        {Submitted.done}
                    </Button>
            </Grid>
        </React.Fragment>
    )
}


export default ThankYou;